import { render, staticRenderFns } from "./_totalInventories.vue?vue&type=template&id=2059d386&scoped=true&"
import script from "./_totalInventories.vue?vue&type=script&lang=js&"
export * from "./_totalInventories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059d386",
  null
  
)

export default component.exports